export const CHANNEL_GROUP = {
    COMMON: 0,
    LIGHT: 1,
    SLIDE: 2,
    EQUIPMENT: 3,
    AWNING: 4,
    MAIN: 5,
    GEN: 6,
    MAIN_HEAD: 7
}

// 油位数量
export const OIL_COUNT = {
    NO: 0,
    GEN: 1,
    GEN_AUX: 2
}

// 判断发电机配置情况
export const HAVE_ALT_AEA = {
    NO_GEN: 0,
    IS_GEN: 1,
    IS_AGS_GEN: 2
}

export const tempUnitMap = {
    0: '℃',
    1: '℉'
}

// 需要加序号的设备列表
export const DEVICE_LIST = ['MPPT', 'DUT', 'Inverter Charger', 'L6', 'ALT', 'Combi', 'DMT']

export const AC_SOURCE = {
    MAIN: 0,
    GEN: 1
}

// 事件名称转化
export const EVENT_MAP = {
    // AC6,
    // ACU,
    // AIR,
    // App,
    // Battery,
    // DTU-BLE,
    // BM500,
    // BS,
    'Inverter Charger': 'Combi',
    'DC Module': 'CRS',
    // CX,
    // ALT,
    // Gas,
    // L6,
    'GY485': 'Level',
    // M10,
    // MTS,
    // P6,
    // PCU,
    // MPPT,
    'TPMS': 'Tire',
    // Truma,
    // Xcm16
}